import React, { useEffect } from "react";
// react-bootstrap components
import { Card, Container, Row, Col, Carousel } from "react-bootstrap";
// required to run holderjs code
import { run as runHolder } from "holderjs/holder";
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  selectPendingIssue,
  unloadPendingIssue,
} from "../features/issue/issueSlice";
// import useAuthorization from "../hooks/useAuthorization";
// import { selectUser } from "../features/user/userSlice";
import slideshow1 from "../assets/images/slideshow/Essilor-Instruments_2880x1068.jpg";
import slideshow2 from "../assets/images/slideshow/Glare-shielding-eyes_2880x1068.jpg";
import slideshow3 from "../assets/images/slideshow/Myopia_2880x1068.jpg";
import slideshow4 from "../assets/images/slideshow/Presbyopia_2880x1068.jpg";
import "../scss/components/shared/Headings.scss";
import { useAccount, useMsal } from "@azure/msal-react";
const Dashboard = () => {
  const dispatch = useDispatch();
  const pendingIssue = useSelector(selectPendingIssue);
  const { accounts } = useMsal();
  const account = useAccount(accounts[0]);
  // const [requests, setRequests] = useState([]);
  // const user = useSelector(selectUser);

  // const handleReloadData = () => {
  //     axios.get(process.env.REACT_APP_API_ENDPOINT + 'compliance/request', getHeader()).then(resp => {
  //         const requests = resp.data;
  //         setRequests(requests);
  //     });
  // }
  // const handleReloadDataMediator = () => {
  //     axios.get(process.env.REACT_APP_API_ENDPOINT + 'compliance/request/mediation', getHeader()).then(resp => {
  //         const requests = resp.data;
  //         setRequests(requests)
  //     });
  // }

  useEffect(() => {
    const ssoId = account?.idTokenClaims?.uid || account?.idTokenClaims?.sub;
    if (ssoId) {
      if (pendingIssue !== 0) {
        axios
          .patch(process.env.REACT_APP_API_ENDPOINT + "compliance/request", {
            requestToken: pendingIssue,
            SSOUserId: ssoId,
            status: "PENDING",
            updatedBy: ssoId,
          })
          .then(() => {
            dispatch(unloadPendingIssue());
          });
      }
    }
  }, [account, dispatch, pendingIssue]);

  // useEffect(() => {
  //     if (user?.userRole === 'MEDIATOR') {
  //         handleReloadDataMediator();
  //     // } else if (user?.userRole === 'ESSILORADMIN') {
  //     //     handleReloadAdminData();
  //     } else {
  //         handleReloadData();
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [user]);

  useEffect(() => {
    runHolder("image-class-name");
  });
  return (
    <Container fluid className="mt-20">
      <Row>
        <Col md="8">
          <Row>
            <Col>
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Essilor Medical Affairs</Card.Title>
                  <p className="card-category">
                    Welcome to the Medical Affairs Portal!
                  </p>
                </Card.Header>
                <Card.Body>
                  <Carousel>
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src={slideshow1}
                        alt="Refraction"
                      />
                      <Carousel.Caption>
                        <h1 className="card__content">Refraction</h1>
                      </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src={slideshow2}
                        alt="Light Management"
                      />

                      <Carousel.Caption>
                        <h1 className="card__content">Light Management</h1>
                      </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src={slideshow3}
                        alt="Myopia"
                      />

                      <Carousel.Caption>
                        <h1 className="card__content">Myopia</h1>
                      </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src={slideshow4}
                        alt="Presbyopia"
                      />

                      <Carousel.Caption>
                        <h1 className="card__content">Presbyopia</h1>
                      </Carousel.Caption>
                    </Carousel.Item>
                  </Carousel>
                </Card.Body>
                <Card.Footer>
                  {/*<div className="legend">*/}
                  {/*    <i className="fas fa-circle text-info"/>*/}
                  {/*    &nbsp;Open <i className="fas fa-circle text-danger"/>*/}
                  {/*    &nbsp;Click <i className="fas fa-circle text-warning"/>*/}
                  {/*    &nbsp;Click Second Time*/}
                  {/*</div>*/}
                  <hr />
                  {/*<div className="stats">*/}
                  {/*    <i className="fas fa-history"/>*/}
                  {/*    &nbsp;Updated 3 minutes ago*/}
                  {/*</div>*/}
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col md="4">
          <Card>
            <Card.Header>
              <Card.Title as="h4">Essilor Medical Affairs</Card.Title>
            </Card.Header>
            <Card.Body>
              <p>
                You have access to your issues above in the "View Issues" tab,
                or you can submit a new issue/request.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
